import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { ChangePasswordError } from 'user/models/errors/ChangePasswordError';
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormWithValidation } from 'shared/form';
import { Card } from 'shared/components';
import { Button } from '@orbita-ui/core';

export const errors = {
  required: 'La contraseña es requerida',
  minLength: (min: number) => `La contraseña debe tener más de ${min} caracteres`,
  maxLength: (max: number) => `La contraseña debe tener un maximo de ${max} caracteres`,
  notMatch: 'Las contraseñas no coinciden',
  alphanumeric:
    'La clave debe contener obligatoriamente caracteres númericos y alfabeticos, al menos una mayúscula y al menos un carácter especial',
};

const minLengthVal = 10;
const maxLengthVal = 36;
const regexVal = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-@.#$!%*?&+()\][_;,:<>])[A-Za-z\d-@.#$!%*?&+()\][_;,:<>]{10,36}$/;

const schema = yup.object().shape({
  newPassword: yup
    .string()
    .required(errors.required)
    .min(minLengthVal, errors.minLength(minLengthVal))
    .max(maxLengthVal, errors.maxLength(maxLengthVal))
    .matches(regexVal, errors.alphanumeric),
  confirmPassword: yup
    .string()
    .required(errors.required)
    .min(minLengthVal, errors.minLength(minLengthVal))
    .max(maxLengthVal, errors.maxLength(maxLengthVal))
    .matches(regexVal, errors.alphanumeric)
    .oneOf([yup.ref('newPassword')], errors.notMatch),
});

export const ResetPasswordForm = ({ onSubmit, changePasswordError }) => {
  const formMethods = useForm({
    resolver: yupResolver(schema),
  });
  const { setError } = formMethods;

  useEffect(() => {
    switch (changePasswordError) {
      case ChangePasswordError.ALREADY_USED_PASSWORD:
        setError(
          'newPassword',
          {
            type: 'invalidKey',
            message:
              'La nueva clave debe ser distinta a las últimas 5 claves utilizadas anteriormente',
          },
          {
            shouldFocus: true,
          },
        );
        break;
    }
  }, [setError, changePasswordError]);

  return (
    <Card>
      <Card.Title>Cambiar Clave</Card.Title>
      <Card.Body $padding>
        <FormWithValidation reactFormHookMethods={formMethods} onSubmit={onSubmit}>
          <FormWithValidation.PasswordInput
            label="Nueva clave"
            data-testid="newPassword-input"
            name="newPassword"
            fullWidth
            registerOptions={{
              required: true,
            }}
          />
          <FormWithValidation.PasswordInput
            label="Confirmación"
            data-testid="confirmPassword-input"
            name="confirmPassword"
            fullWidth
            registerOptions={{
              required: true,
            }}
          />
          <Row>
            <Col className="text-end">
              <Button type="submit">Aceptar</Button>
            </Col>
          </Row>
        </FormWithValidation>
      </Card.Body>
    </Card>
  );
};
